module.exports = __webpack_public_path__ + "static/media/preview_stamp_campaign_details_page_task_startted_brand.6958da1c.svg";